module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
  var __output = [], __append = __output.push.bind(__output);
  with (locals || {}) {
    ; __append("<div class=\"user-views\">\n    <h4 class=\"title\">Сохраненые представления</h4>\n    <table class=\"views-list w100\" name=\"views-list\">\n        ")
    ;  if (views.length) { 
    ; __append("\n        ")
    ;  _.each(views, function(view) { 
    ; __append("\n        ")
    ; __append( UI.Template.render(control.userViewRowTemplate, { control: control, view: view }) )
    ; __append("\n        ")
    ;  }) 
    ; __append("\n        ")
    ;  } else { 
    ; __append("\n        <tr class=\"empty\">\n            <td>Нет представлений</td>\n        </tr>\n        ")
    ;  } 
    ; __append("\n    </table>\n\n    <div class=\"footer\">\n        <hr />\n        <span class=\"gl-pointer link gis-underline\" on-click=\"onSaveCurrentViewClick\">Сохранить текущее предтавление</span>\n    </div>\n    <span class=\"icon-24 icon-arrow-right2 back\" title=\"Назад\" on-click=\"onUserViewsBackClick\"></span>\n</div>\n")
  }
  return __output.join("");

}